import type { RouteRecordRaw } from "vue-router";
import OverviewPage from "./pages/OverviewPage.vue";
import MonitoringPage from "./pages/MonitoringPage.vue";
import ChatAnalysisPage from "./pages/ChatAnalysisPage.vue";
import GoodStuffPage from "./pages/GoodStuffPage.vue";
import ProjectComponentPage from "./pages/ProjectComponentPage.vue";
import StickersPage from "./pages/StickersPage.vue";
import UserProfilesPage from "./pages/UserProfilesPage.vue";
import ConfigPage from "./pages/ConfigPage.vue";
import TtsPage from "./pages/TtsPage.vue";
import MemoryPage from "./pages/MemoryPage.vue";
import PersonasPage from "./pages/PersonasPage.vue";
import PersonaDetailPage from "./pages/PersonaDetailPage.vue";
import AttitudesPage from "./pages/AttitudesPage.vue";
import AffinityPage from "./pages/AffinityPage.vue";
import GrudgesPage from "./pages/GrudgesPage.vue";
import TaboosPage from "./pages/TaboosPage.vue";
import PluginsPage from "./pages/PluginsPage.vue";
import LearningPage from "./pages/LearningPage.vue";
import DataImportPage from "./pages/DataImportPage.vue";
import QQLoginPage from "./pages/QQLoginPage.vue";
import DebugPage from "./pages/DebugPage.vue";
import EvalsPage from "./pages/EvalsPage.vue";
import AuditPage from "./pages/AuditPage.vue";

export const routes: RouteRecordRaw[] = [
  { path: "/", component: OverviewPage },
  { path: "/personas", component: PersonasPage },
  { path: "/personas/:name", component: PersonaDetailPage },
  { path: "/attitudes", component: AttitudesPage },
  { path: "/affinity", component: AffinityPage },
  { path: "/grudges", component: GrudgesPage },
  { path: "/taboos", component: TaboosPage },
  { path: "/stickers", component: StickersPage },
  { path: "/plugins", component: PluginsPage },
  { path: "/learning", component: LearningPage },
  { path: "/config", component: ConfigPage },
  { path: "/data", component: DataImportPage },
  { path: "/tts", component: TtsPage },
  { path: "/qqlogin", component: QQLoginPage },
  { path: "/debug", component: DebugPage },
  { path: "/observability", component: MonitoringPage },
  { path: "/chat-analysis", component: ChatAnalysisPage },
  { path: "/good-stuff", component: GoodStuffPage },
  { path: "/project-internal", component: ProjectComponentPage },
  { path: "/memory", component: MemoryPage },
  { path: "/evals", component: EvalsPage },
  { path: "/users", component: UserProfilesPage },
  { path: "/audit", component: AuditPage }
];
